export const UPDATE_RISK_COMMENT_STARTED = "UPDATE_RISK_COMMENT_STARTED";
export const UPDATE_RISK_COMMENT_SUCCESS = "UPDATE_RISK_COMMENT_SUCCESS";
export const UPDATE_RISK_COMMENT_FAILED = "UPDATE_RISK_COMMENT_FAILED";

export const LOAD_RISK_COMMENT_STARTED = "LOAD_RISK_COMMENT_STARTED";
export const LOAD_RISK_COMMENT_SUCCESS = "LOAD_RISK_COMMENT_SUCCESS";
export const LOAD_RISK_COMMENT_FAILED = "LOAD_RISK_COMMENT_FAILED";
